export default {"src":"/_next/static/media/Champagne.b8151ca0.svg","height":165,"width":282,"blurWidth":0,"blurHeight":0};